<template>
  <div class="emission_reduce_page">
    <dec-block-title>减排累计TOP5(t)</dec-block-title>
    <dv-charts :option="option" />
  </div>
</template>

<script>
import decBlockTitle from '../decorations/blockTitle2'
// import { queryToMD5 } from "@/utils/md5_query"

export default {
  name: 'emissionReduce',
  components: {
    decBlockTitle
  },
  props: {
    contentData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      option: {}
    }
  },
  watch: {
    'contentData': {
      handler: function(data) {
        if (!data) {
          return false
        }
        if (data.length === 0) {
          this.option = {}
        } else {
          this.option = {
            // color: '#fff',
            xAxis: {
              min: 0,
              axisLine: {
                style: {
                  stroke: '#324D4D',
                  lineDash: [5, 2]
                }
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                style: {
                  fontSize: 12,
                  fill: '#D0D0D0'
                }
              },
              splitLine: {
                stroke: 'red',
                lineWidth: 1
              },
              data: data.filter((item, index) => index < 5).map(item => {
                return item.N || ""
              })
            },
            yAxis: {
              min: 0,
              data: 'value',
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                style: {
                  fontSize: 12,
                  fill: '#D0D0D0'
                }
              },
              splitLine: {
                style: {
                  stroke: '#324D4D',
                  lineWidth: 1,
                  lineDash: [5, 2]
                }
              }
            },
            series: [
              {
                xAxisIndex: 0,
                yAxisIndex: 0,
                data: data.filter((item, index) => index < 5).map(item => {
                  return item.V
                }),
                type: 'bar',
                barWidth: 15,
                gradient: {
                  color: ['rgba(104,224,207,1)', 'rgba(32,156,255,1)']
                }
              }
            ],
            grid: {
              left: 30,
              top: 20,
              right: 0,
              bottom: 20
            }
          }
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.emission_reduce_page {
  width: 100%;
  // height: 33%;
  box-sizing: border-box;

  .dv-charts-container {
    height: calc(100% - 45px);
  }
}
</style>
